import isMonday from 'date-fns/isMonday';
import previousMonday from 'date-fns/previousMonday';

export function getLastMonday(date) {
  return isMonday(date) ? date : previousMonday(date);
}
